import httpClient, { ApiResponse } from "./httpClient";
import { Role } from "@/interfaces";
import { pagination } from "@/store/modules";
import { PaginationDetails } from "@/interfaces/Pagination";

export const getHappySadFeedbackForReport = async (pagination: PaginationDetails, name: string): Promise<ApiResponse<Role>> => {
  return httpClient.get(`/feedback/report?pageNumber=${pagination.pageNumber}&pageSize=${pagination.pageSize}&name=${name}`);
}
